var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div'),(_vm.datas)?_c('ListPageV3',{attrs:{"datas":_vm.datas}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }